module.exports = __webpack_public_path__ + "img/HP_00_mono_AE_00001.c7730632.png";